/* eslint-disable no-useless-escape */
export const ONLY_NUMBER_REG_EXP = /^[0-9]*$/
export const DECIMAL_NUMBER_REG_EXP = /^[0-9]\d*(\.\d+)?$/
export const NEW_PASSWORD_REG_EXP = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,20}$/
export const EMAIL_REG_EXP = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
// /^\s*(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/

export const SITE_NAME = 'Coal Analytics'
export const REACT_APP_ENV = process.env.REACT_APP_ENV || 'production'
export const DOMAIN = process.env.REACT_APP_DOMAIN || 'http://localhost:3000'
export const S3_PREFIX = process.env.REACT_APP_S3_PREFIX || 'https://coalbkt.s3.ap-south-1.amazonaws.com/'
export const API_URL = 'https://coal-backend.lc.webdevprojects.cloud'

export const STATUS = {
  p: { label: 'Pending', value: 'p' },
  a: { label: 'Approve', value: 'a' },
  r: { label: 'Reject', value: 'r' }
}

export const ADMIN_LOGS_MODULE = {
  sb: 'Sub Admin',
  u: 'User',
  a: 'Auth'
}
export const ADMIN_LOGS_ACTION = {
  i: 'INSERT',
  d: 'DELETE',
  v: 'VIEW',
  u: 'UPDATE',
  a: 'APPROVE',
  m: 'MERGE',
  up: 'UPLOAD',
  l: 'LOGIN',
  lo: 'LOGOUT',
  r: 'REJECT',
  p: 'PUBLISH',
  ust: 'UPDATE_STATUS',
  vf: 'VERIFY'
}

export const permissionData = {

  VIEW_USER: 'VIEW_USER',
  CREATE_USER: 'CREATE_USER',
  EDIT_USER: 'EDIT_USER',
  DELETE_USER: 'DELETE_USER'

}

export const COMPANY_LIST = [
  { value: 'apple', label: 'Apple Inc.' },
  { value: 'google', label: 'Google LLC' },
  { value: 'microsoft', label: 'Microsoft Corporation' },
  { value: 'amazon', label: 'Amazon.com, Inc.' },
  { value: 'facebook', label: 'Meta Platforms, Inc.' },
  { value: 'tesla', label: 'Tesla, Inc.' },
  { value: 'netflix', label: 'Netflix, Inc.' },
  { value: 'oracle', label: 'Oracle Corporation' },
  { value: 'adobe', label: 'Adobe Inc.' },
  { value: 'ibm', label: 'IBM Corporation' }
]

export const VEHICLE_TYPES = [
  { id: 1, value: 'CAMPER', label: 'CAMPER' },
  { id: 2, value: 'HYVA', label: 'HYVA' },
  { id: 3, value: 'JEEP', label: 'JEEP' },
  { id: 4, value: 'PAYLOADER', label: 'PAYLOADER' },
  { id: 5, value: 'PICKUP', label: 'PICKUP' },
  { id: 6, value: 'SCORPIO', label: 'SCORPIO' },
  { id: 7, value: 'TANKER', label: 'TANKER' }
]

export const WORKSITE_TYPES = [
  { value: 'FACE', label: 'FACE' },
  { value: 'SIDING', label: 'RAILWAY SIDING' },
  { value: 'STOCK', label: 'STOCK YARD' }
]

export const DESIGNATION_TYPES = [
  { value: 'Driver', label: 'Driver' },
  { value: 'Operator', label: 'Operator' },
  { value: 'Supervisor', label: 'Supervisor' },
  { value: 'Mechanic', label: 'Mechanic' },
  { value: 'Helper', label: 'Helper' },
  { value: 'Driver Without CMPF Number', label: 'Driver Without CMPF Number' }
]

export const LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'hi', label: 'Hindi' }
]

export const SHIFTS = [
  { label: 'Shift A', value: 'Shift A' },
  { label: 'Shift B', value: 'Shift B' },
  { label: 'Shift C', value: 'Shift C' }
]

export const BLOODGROUPS = [
  { label: 'N/A', value: 'N/A' },
  { label: 'A+', value: 'A+' },
  { label: 'A-', value: 'A-' },
  { label: 'B+', value: 'B+' },
  { label: 'B-', value: 'B-' },
  { label: 'AB+', value: 'AB+' },
  { label: 'AB-', value: 'AB-' },
  { label: 'O+', value: 'O+' },
  { label: 'O-', value: 'O-' }
]
